import React, { useCallback, useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import TableListFooter from '../components/TableListFooter';
import { fetchAnketOzet, fetchAnketler } from '../services/anketService';
import './AnketlerPage.css';

const KART_SIRA = [
  { anahtar: 'genel', hedef: 'musteri', set: '', ikon: 'fa-chart-pie', ton: 'mavi' },
  { anahtar: 'musteri_kurulum', hedef: 'musteri', set: 'musteri_kurulum', ikon: 'fa-play-circle', ton: 'yesil' },
  { anahtar: 'musteri_ariza', hedef: 'musteri', set: 'musteri_ariza', ikon: 'fa-tools', ton: 'turuncu' },
  { anahtar: 'bayi', hedef: 'bayi', set: '', ikon: 'fa-store', ton: 'mor' },
  { anahtar: 'teknik_servis', hedef: 'teknik_servis', set: '', ikon: 'fa-user-cog', ton: 'teal' },
];

const tarihYaz = (value) => {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' });
};

export default function AnketlerPage() {
  const { user } = useAuth();
  const admin = user?.rol === 'admin';
  const [params, setParams] = useSearchParams();
  const hedef = params.get('hedef') || 'musteri';
  const set = params.get('set') || '';
  const sayfa = Math.max(1, parseInt(params.get('sayfa'), 10) || 1);
  const [ozet, setOzet] = useState(null);
  const [liste, setListe] = useState([]);
  const [sayfalama, setSayfalama] = useState({ toplam: 0, toplamSayfa: 1, mevcutSayfa: 1 });
  const [acik, setAcik] = useState(null);
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(true);

  const yukle = useCallback(async () => {
    setYukleniyor(true);
    setHata('');
    try {
      const [ozetRes, listeRes] = await Promise.all([
        fetchAnketOzet(),
        fetchAnketler({ hedef, set, sayfa }),
      ]);
      setOzet(ozetRes?.veri || null);
      setListe(listeRes?.veri?.kayitlar || []);
      setSayfalama(listeRes?.veri?.sayfalama || { toplam: 0, toplamSayfa: 1, mevcutSayfa: 1 });
      setAcik(null);
    } catch (err) {
      setHata(err?.message || 'Liste alınamadı');
    } finally {
      setYukleniyor(false);
    }
  }, [hedef, set, sayfa]);

  useEffect(() => { yukle(); }, [yukle]);

  const kartSec = (kart) => {
    const next = new URLSearchParams();
    next.set('hedef', kart.hedef);
    if (kart.set) next.set('set', kart.set);
    setParams(next);
  };

  const kartVeri = (anahtar) => {
    if (!ozet) return { ad: '', yuzde: 0, adet: 0 };
    if (anahtar === 'genel') return ozet.genel;
    return ozet.kartlar?.[anahtar] || { ad: anahtar, yuzde: 0, adet: 0 };
  };

  const seciliKart = (kart) => (
    kart.hedef === hedef && (kart.set || '') === (hedef === 'musteri' ? set : '')
  );

  return (
    <main className="main-content anketler-sayfa">
      <div className="content-header">
        <div>
          <h1>Anketler</h1>
        </div>
        {admin && (
          <div className="content-header-actions">
            <Link className="secondary-btn" to="/anketler/sorular">Soru setleri</Link>
            <Link className="primary-btn" to="/anketler/kampanyalar">Kampanyalar</Link>
          </div>
        )}
      </div>

      <div className="anket-kpi-grid">
        {KART_SIRA.map((kart) => {
          const veri = kartVeri(kart.anahtar);
          return (
            <button
              key={kart.anahtar}
              type="button"
              className={`anket-kpi${seciliKart(kart) ? ' secili' : ''}`}
              data-ton={kart.ton}
              onClick={() => kartSec(kart)}
            >
              <span className="anket-kpi-ikon" aria-hidden>
                <i className={`fas ${kart.ikon}`} />
              </span>
              <span className="anket-kpi-govde">
                <span className="anket-kpi-deger">%{veri.yuzde}</span>
                <span className="anket-kpi-etiket">{veri.ad}</span>
                <span className="anket-kpi-alt">{veri.adet} cevap</span>
              </span>
            </button>
          );
        })}
      </div>

      {hata ? <p>{hata}</p> : null}

      <div className="card">
        <table className="admins-table anket-tablo">
          <thead>
            <tr>
              <th>{hedef === 'musteri' ? 'Müşteri' : 'Alıcı'}</th>
              <th>Set</th>
              <th>Puan</th>
              <th>{hedef === 'musteri' ? 'Teknik servis' : 'Kampanya'}</th>
              <th>Tarih</th>
            </tr>
          </thead>
          <tbody>
            {!yukleniyor && liste.length === 0 && (
              <tr><td colSpan={5}>Cevap yok</td></tr>
            )}
            {liste.map((satir) => (
              <React.Fragment key={satir.id}>
                <tr
                  className={`anket-satir${acik === satir.id ? ' acik' : ''}`}
                  onClick={() => setAcik(acik === satir.id ? null : satir.id)}
                >
                  <td>{satir.aliciAd}</td>
                  <td><span className={`anket-rozet anket-rozet--${satir.set}`}>{satir.setAdi}</span></td>
                  <td><span className="anket-puan">{satir.puan}</span></td>
                  <td>{hedef === 'musteri' ? satir.teknikServisAd : satir.kampanyaBaslik}</td>
                  <td>{tarihYaz(satir.cevapTarihi)}</td>
                </tr>
                {acik === satir.id && (
                  <tr className="anket-detay">
                    <td colSpan={5}>
                      <div className="anket-detay-kutu">
                        {satir.cevaplar.map((c, i) => (
                          <div key={`${satir.id}-${i}`} className="anket-cevap-satir">
                            <span>{c.metin}</span>
                            <span className={`anket-cevap ${c.olumluMu ? 'olumlu' : 'olumsuz'}`}>
                              {c.cevap === 'evet' ? 'Evet' : 'Hayır'}
                            </span>
                          </div>
                        ))}
                        {satir.istekSikayet ? (
                          <p className="anket-istek-metin">{satir.istekSikayet}</p>
                        ) : null}
                        {satir.randevu?.servisKaydiId && satir.randevu?.id ? (
                          <Link
                            className="anket-randevu-link"
                            to={`/service-records/${satir.randevu.servisKaydiId}/appointments/${satir.randevu.id}`}
                          >
                            {satir.randevu.numara || 'Randevu'}
                          </Link>
                        ) : null}
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
        <TableListFooter
          totalRecords={sayfalama.toplam}
          currentPage={sayfalama.mevcutSayfa}
          totalPages={sayfalama.toplamSayfa}
          onPageChange={(p) => {
            const next = new URLSearchParams(params);
            next.set('sayfa', String(p));
            setParams(next);
          }}
          loading={yukleniyor}
          embedded
        />
      </div>
    </main>
  );
}
